var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"paperDetails"}},[_c('Header'),(_vm.deviceInfo.pc || _vm.deviceInfo.tabletPc)?_c('PaperDetailsPC',{staticClass:"paper-details"}):_c('div',{staticClass:"paper-details"}),_c('Fotter'),_c('Watermark'),(!(_vm.deviceInfo.pc || _vm.deviceInfo.tabletPc))?_c('PcDialog'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }